import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { CROSSTAB_VIEWER_GRID_TYPE } from '../../../util/CrosstabUtils';

import CrosstabViewerGridBodyRow from './CrosstabViewerGridBodyRow';

const CrosstabViewerGridBodyRows = ({
  columnDefinitions,
  renderBodyCell,
  renderBodyRow,
  tableData,
  cellElementList,
  viewerGridType,
  selectedDropdownColumn,
  horizontalPageNo,
  horizontalEPP,
  verticalPageNo,
  verticalEPP,
  selectedIndex,
}) => {
  const renderBodyRows = rowList => {
    const lastRenderedRow =
      verticalPageNo + verticalEPP < rowList.length
        ? verticalPageNo + verticalEPP
        : rowList.length;
    return rowList.slice(verticalPageNo, lastRenderedRow).map(rowData => (
      <CrosstabViewerGridBodyRow
        key={uuid()}
        {...{
          horizontalPageNo,
          horizontalEPP,
          columnDefinitions,
          renderBodyCell,
          renderBodyRow,
          rowData,
          cellElementList,
          viewerGridType,
          selectedDropdownColumn,
          filterType: tableData.conditionalFormatting,
          highlightAndFilter: tableData.highlightAndFilter,
          selectedIndex,
        }}
      />
    ));
  };

  const renderBodyRowsTrend = () => {
    const trendRows = [];
    const rowsLength =
      tableData.crosstabPerStudy[0][tableData.selectedBase].rowList.length;
    const lastRenderedRow =
      verticalPageNo + verticalEPP < rowsLength
        ? verticalPageNo + verticalEPP
        : rowsLength;
    for (
      let rowIndex = verticalPageNo;
      rowIndex < lastRenderedRow;
      rowIndex += 1
    ) {
      const rowsPerStudy = tableData.crosstabPerStudy.map(
        crosstabPerStudy =>
          crosstabPerStudy[selectedIndex].rowList[rowIndex],
      );

      trendRows.push(
        <CrosstabViewerGridBodyRow
          key={uuid()}
          {...{
            horizontalEPP,
            horizontalPageNo,
            columnDefinitions,
            renderBodyCell,
            renderBodyRow,
            rowsPerStudy,
            cellElementList,
            viewerGridType,
            selectedDropdownColumn,
          }}
        />,
      );
    }
    return trendRows;
  };

  return (
    <tbody>
      {viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND
        ? renderBodyRowsTrend()
        : renderBodyRows(
            tableData.crosstabPerStudy[0][tableData.selectedBase].rowList,
          )}
    </tbody>
  );
};

CrosstabViewerGridBodyRows.propTypes = {
  tableData: PropTypes.shape({}),
  viewerGridType: PropTypes.oneOf(Object.values(CROSSTAB_VIEWER_GRID_TYPE)),
  selectedDropdownColumn: PropTypes.number,
  columnDefinitions: PropTypes.arrayOf(PropTypes.shape()),
  cellElementList: PropTypes.arrayOf(PropTypes.shape()),
  renderBodyRow: PropTypes.func,
  renderBodyCell: PropTypes.func,
  horizontalPageNo: PropTypes.number,
  horizontalEPP: PropTypes.number,
  verticalPageNo: PropTypes.number,
  verticalEPP: PropTypes.number,
};

export default CrosstabViewerGridBodyRows;
